import React from 'react'
import CheckInactiveSVG from "../../../assets/icons/check-inactive.svg";
export const CheckInactive: React.FC = () => {
  return (
    <img src={CheckInactiveSVG} alt="" className="w-[25px] h-[25px]" />
  )
}
